export var languageAPIHeader = function (_a) {
    var language = _a.language, defaultLanguage = _a.defaultLanguage;
    return ({
        "X-Language": language,
        "X-Default-Language": defaultLanguage,
    });
};
